let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("3aKJV")).then(() => parcelRequire('gYv7J'));